import { IconButton as MuiIconButton } from "@mui/material";
import { styled } from "@mui/material/styles";

const StyledIconButton = styled(MuiIconButton)`
  &:hover {
    box-shadow: ${(props) => props.theme.palette.primary.main} 0px 0px 15px 0px;
    background-color: ${(props) => props.theme.palette.primary.main}50;
    background-image: radial-gradient(
      circle,
      ${(props) => props.theme.palette.primary.main}50,
      ${(props) => props.theme.palette.primary.main}25,
      ${(props) => props.theme.palette.primary.main}00
    );
  }

  &:active {
    box-shadow: ${(props) => props.theme.palette.primary.main} 0px 0px 15px 0px;
    background-color: ${(props) => props.theme.palette.primary.main}50;
    background-image: radial-gradient(
      circle,
      ${(props) => props.theme.palette.primary.main}0,
      ${(props) => props.theme.palette.primary.main}25,
      ${(props) => props.theme.palette.primary.main}00
    );
  }

  /* box-shadow: ${(props) =>
    props?.$active === true
      ? `${props.theme.palette.primary.main} 0px 0px 15px 0px;`
      : `none`} */
  /* background-color: ${(props) =>
    props?.$active === true
      ? `${props.theme.palette.primary.main}50`
      : `transparent;`}; */
  /* background-image:${(props) =>
    props?.$active === true
      ? `radial-gradient(circle, ${props.theme.palette.primary.main}50, ${props.theme.palette.primary.main}25, ${props.theme.palette.primary.main}00);`
      : `none`} */

  &:disabled {
    opacity: 0.4;
    background-color: ${(props) => props.theme.palette.primary.main};
    color: ${(props) => props.theme.palette.primary.contrastText};
  }
`;

const IconButton = ({ ...props }) => {
  return <StyledIconButton component="button" {...props} />;
};

export default IconButton;
